export default "__VITE_ASSET__oOH1TvqE__"